import SelectLanguageChange from "./SelectLanguageChange";
import LanguageChange from "./LanguageChange";

const mod = { LanguageChange, SelectLanguageChange };

export default mod;
